export const PUBLIC_URL = process.env.PUBLIC_URL;

export const getAssetImagePath = (image: string) =>
  `${PUBLIC_URL}/images/${image}`;

export const backgroundImage = getAssetImagePath('bgImg-min.png');
